module.exports = __webpack_public_path__ + "img/hehongtao.accc5c74.jpg";